import { ReactComponent as InformationCircle } from 'assets/information-circle.svg';
import { t } from 'i18next';

const LoginPasswordRule = ({ iconColor = '' }: { iconColor?: string }) => {
  return (
    <div className="ml-1 tooltip tooltip-right text-left" data-tip={t('login.passwordRule')}>
      <InformationCircle className={`w-4 h-4 ${iconColor}`} />
    </div>
  );
};

export default LoginPasswordRule;
